import { type ChangeEvent, type ReactNode } from "react";
import { Modal, Button, Typography, Divider, Input } from "antd";
import { CloseIcon } from "@/shared/assets/svg/icons";
import type { ModalAction, ModalStateFirst } from "../model/types";
import "./modal-info.scss";

const { Text } = Typography;

interface ModalInfoProps {
  visible: boolean;
  confirmText?: string;
  cancelText?: string;
  onConfirm?: () => void | null;
  handleAction?: (action: ModalAction, actionPayload?: any) => void;
  modalState?: ModalStateFirst;
  onCancel?: () => void;
  title?: string;
  Info?: string | ReactNode;
  inputValue?: string;
  onChangeValue?: (e: ChangeEvent<HTMLTextAreaElement>) => void;
  inputPlaceholder?: string;
  isInputModal?: boolean;
  isDivider?: boolean;
  confirmDisabled?: boolean;
  inputError?: string;
  onValidationError?: () => void;
}

export function ModalInfo({
  visible,
  confirmText = "Отправить",
  cancelText = "Отменить",
  onConfirm,
  handleAction,
  modalState,
  onCancel,
  title,
  Info,
  inputPlaceholder,
  inputValue,
  onChangeValue,
  isInputModal,
  isDivider,
  confirmDisabled,
  inputError,
  onValidationError,
}: ModalInfoProps) {
  const handleConfirm = () => {
    if (isInputModal && !inputValue?.trim()) {
      if (onValidationError) {
        onValidationError();
      }
      return;
    }
    
    if (onConfirm) {
      onConfirm();
    } else if (handleAction && modalState?.action) {
      let updatedAction = modalState.action;
      
      if (isInputModal && inputValue && updatedAction.type !== "" && updatedAction.type !== "CLEAR_SELECTION") {
        updatedAction = {
          ...updatedAction,
          payload: {
            ...updatedAction.payload,
            comment: inputValue,
          },
        } as ModalAction;
      }
      
      handleAction(updatedAction);
    } else {
      return null;
    }
    if (onCancel) {
      onCancel();
    }
  };
  return (
    <Modal
      visible={visible}
      onCancel={onCancel}
      footer={null}
      // width={400}
      centered
      closeIcon={
        <span className="modal-info-close-icon">
          <CloseIcon />
        </span>
      }
      title={title}
    >
      <div>
        {typeof Info === "string" ? <Text>{Info}</Text> : Info}
        {isInputModal ? (
          <div>
            <div className="modal-info-input-label">{inputPlaceholder}</div>
            <Input.TextArea 
              value={inputValue} 
              onChange={onChangeValue} 
              status={inputError ? "error" : ""}
              maxLength={255}
              showCount
            />
            {inputError && (
              <div className="modal-info-input-error">
                {inputError}
              </div>
            )}
          </div>
        ) : null}
        {isDivider || isInputModal ? <Divider /> : null}
        <div className="modal-info-actions">
          {(onConfirm && confirmText) ||
          (handleAction && modalState?.action) ? (
            <Button
              type="primary"
              onClick={handleConfirm}
              style={{ marginRight: "16px" }}
              disabled={confirmDisabled}
            >
              {confirmText}
            </Button>
          ) : null}
          {onCancel && cancelText ? (
            <Button onClick={onCancel}>{cancelText}</Button>
          ) : null}
        </div>
      </div>
    </Modal>
  );
}
